export default __webpack_public_path__ + "static/media/Clearance_Specials_Web_Banner_Desktop_V4.1.767a38e7.jpg";